export default {
  REACT_APP_API_BASE: process.env.REACT_APP_API_BASE || 'http://localhost:8000/'
  }